import { funnel } from 'data';
import { Flex, Icon, Text } from 'mymoria-ui/components';
import { FlexboxProps, LayoutProps, SpaceProps } from 'mymoria-ui/interfaces';
import { styled } from 'mymoria-ui/utils';
import { FunctionComponent } from 'react';

const { highlights } = funnel.contactDetails;

export interface HighlightsProps extends FlexboxProps, SpaceProps, LayoutProps {}

const StyledCheck = styled(Icon.Check)(
  ({ theme: { space, colors } }) => `
  fill: ${colors.primary};
  min-width: 36px;
  min-height: 38px;
  margin-right: ${space.small};
`,
);

const Description = styled.span`
  font-weight: normal;
`;

const Highlights: FunctionComponent<HighlightsProps> = ({ ...props }) => (
  <Flex
    flexWrap="wrap"
    flexDirection={['column', 'row']}
    justifyContent={['flex-start', 'center']}
    {...props}
  >
    {highlights.map((highlight, index) => (
      <Flex key={index} pb="medium" alignItems="center" mx={6}>
        <StyledCheck width={36} height={38} />
        <Text fontWeight="bold" pt={0}>
          {highlight.name}:<Description>{` ${highlight.description}`}</Description>
        </Text>
      </Flex>
    ))}
  </Flex>
);

export default Highlights;
